var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 11.5625C15.4375 12.4742 15.0753 13.3485 14.4307 13.9932C13.786 14.6378 12.9117 15 12 15C11.0883 15 10.214 14.6378 9.56932 13.9932C8.92466 13.3485 8.5625 12.4742 8.5625 11.5625C8.5625 10.6508 8.92466 9.77648 9.56932 9.13182C10.214 8.48716 11.0883 8.125 12 8.125C12.9117 8.125 13.786 8.48716 14.4307 9.13182C15.0753 9.77648 15.4375 10.6508 15.4375 11.5625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5625C1 11.5625 5.125 4 12 4C18.875 4 23 11.5625 23 11.5625C23 11.5625 18.875 19.125 12 19.125C5.125 19.125 1 11.5625 1 11.5625ZM12 16.375C13.2764 16.375 14.5004 15.868 15.403 14.9655C16.3055 14.0629 16.8125 12.8389 16.8125 11.5625C16.8125 10.2861 16.3055 9.06207 15.403 8.15955C14.5004 7.25703 13.2764 6.75 12 6.75C10.7236 6.75 9.49957 7.25703 8.59705 8.15955C7.69453 9.06207 7.1875 10.2861 7.1875 11.5625C7.1875 12.8389 7.69453 14.0629 8.59705 14.9655C9.49957 15.868 10.7236 16.375 12 16.375Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.babd697f.svg";
export { ForwardRef as ReactComponent };